<template>
  <div :class="'base-create ' + (currentStep > componentStep ? 'create-class-com-disable' : '')">
    <Header :addLearnerStep="componentStep" :title="title"></Header>
    <div class="base-create-body">
      <licenses-avai
        :headAvaiMemberships="combineHeadAvailableMemberships"
        :selectedLicense="selectedLicense"
        @assignAll="handleAssignAll"
        @clearAll="handleClearAll"
        showRadio
      />
      <el-form class="auth-form" :model="form" :rules="rules" ref="form">
        <el-table :data="dataUsers" style="width: 100%" class="no-pointer" :height="600">
          <el-table-column prop="text" :label="$t('classes.classes_details.edit_class.table.email')" width="300">
            <template slot-scope="scope">
              <div class="owner-info">
                <p>{{ scope.row.text }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="text" :label="$t('classes.classes_details.edit_class.table.first_name')" width="150">
            <template slot-scope="scope">
              <div class="owner-info">
                <p>{{ scope.row.first_name }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="text" :label="$t('classes.classes_details.edit_class.table.last_name')">
            <template slot-scope="scope">
              <div class="owner-info">
                <p>{{ scope.row.last_name }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="text"
            :label="$t('classes.classes_details.edit_class.table.exist_license')"
            max-width="180"
          >
            <template slot-scope="scope">
              <!-- <elsa-select class="select-membership-single" name="selectedMembership" :options="avaiMemberships" no-data-text="No plan available" @change="(planSelected) => assignLicense(scope.row.id, planSelected)" v-model.lazy="scope.row.plan_id" v-bind:disabled="scope.row.disabled" /> -->
              <div class="wrap-tags">
                <el-tag
                  v-for="value in findExistLicense(scope.row)"
                  :key="value.value"
                  type="success"
                  class="exist_license"
                >
                  {{ value.plan_label }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="text" :label="$t('classes.classes_details.edit_class.table.license')" width="150">
            <template slot-scope="scope">
              <elsa-select
                :options="filterOptions(scope.row)"
                :value="userSelectedLicense.hasOwnProperty(scope.row.id) ? userSelectedLicense[scope.row.id] : ''"
                class="select-membership-single"
                clearable
                name="selectedMembership"
                no-data-text="No plan available"
                @change="value => handleChangeUserSelectedLicense(value, scope.row)"
              />
              <!-- v-model.lazy="scope.row.valueNewLicense" -->
              <!-- @change="planSelected => assignLicense(scope.row.id, planSelected)" -->
            </template>
          </el-table-column>
          <el-table-column width="50">
            <template slot-scope="scope">
              <span
                class="remove-user"
                @click="removeUser(scope.row.id)"
                :title="$t('school_labels.remove_student_from_group')"
                :data-index="scope.row.id"
              >
                <i class="elsa-icon-grey-delete" />
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="elsa-table-layout-footer">
          <pagination :page-size="maxNumberOfElements" :total="total" :pager-counter="5" :current-page.sync="page" />
          <over-table-pagination :currentPage="page" :pageSize="maxNumberOfElements" :total="total" />
        </div>
      </el-form>
    </div>
    <delete-classes-user
      :dialogVisible="modals.showRemoveAccountModal"
      v-on:closed="modals.showRemoveAccountModal = false"
      @doRemoveStudentFromClass="handelRemoveFromClasses"
    />
    <confirm-reassign-user-license
      :dialogVisible="modals.showAssignLicenseModal"
      v-on:closed="modals.showAssignLicenseModal = false"
      @cancelAssignLicenseToStudent="cancelAssignLicense"
      @doAssignLicenseToStudent="handleAssignLicense"
      :licenseDisplayName="membershipSelectedDisplayName"
      :userDisplayName="userAssignMembershipSelectedDisplayName"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "@/utils/axios";
import { successMessage, warningMessage } from "@/utils/messages";
import { always } from "ramda";
import Pagination from "@/components/common/Pagination";
import ElsaSelect from "@/components/common/Select";
import OverTablePagination from "@/components/common/OverTablePagination";
import DeleteClassesUser from "@/components/modals/classes/DeleteClassesUsers";
import ConfirmReassignUserLicense from "@/components/modals/classes/ConfirmReassignUserLicense";
import {
  NUMBER_ELEMENTS_PER_PAGE,
  PAGE_COUNTER,
  PLAN_MONTH_DURATION,
} from "@/constants/generic";
import { addMonths } from "date-fns";
import { formatDate } from "@/utils/formatDate";
import Header from "@/components/common/add-learners/Header";
import LicensesAvai from "@/components/common/add-learners/LicensesAvai";
import { getPlanLabel } from "@/helpers/functions";

export default {
  components: {
    OverTablePagination,
    ElsaSelect,
    Pagination,
    DeleteClassesUser,
    ConfirmReassignUserLicense,
    Header,
    LicensesAvai,
  },
  data() {
    return {
      selectedLicense: {},
      dataUsers: [],
      example: "",
      form: {},
      rules: {},
      orgPlanDetails: [],
      currentPage: 1,
      total: 0,
      modals: {
        showRemoveAccountModal: false,
        showAssignLicenseModal: false,
      },
      allPlans: [],
      userIdRemoved: null,
      planSelected: null,
      userIdAssignMembershipSelected: null,
      membershipSelectedDisplayName: "",
      userAssignMembershipSelectedDisplayName: "",
      userSelectedLicense: {},
    };
  },
  computed: {
    maxNumberOfElements: always(NUMBER_ELEMENTS_PER_PAGE),
    pageCounter: always(PAGE_COUNTER),
    page: {
      get() {
        return this.currentPage;
      },
      async set(newPage) {
        return await this.fetchPage(newPage);
      },
    },
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
      class: "classes/getBuildingClass",
      currentOrganizationId: "organization/currentOrganizationId",
      currentOrganization: "organization/currentOrganization",
    }),
    title() {
      return this.$t("classes.classes_details.edit_class.table.title");
    },
    sortedOrgPlans() {
      const plans = [...this.orgPlanDetails];
      const sortedData = plans.sort((a, b) => a.id - b.id); // sort by id from earliest to latest
      const data = [];

      sortedData.forEach(p => {
        const expire_date_label = p.expire_date ? " - exp. on " + p.expire_date : "";
        const plan_name = getPlanLabel(p.product_type, p.package);
        const plan_label = p.qty - p.qty_assigned + " " + plan_name + expire_date_label;
        data.push({ ...p, plan_label, plan_name, expire_date_label });
      });

      data.sort((a, b) => {
        if (a.expire_date && !b.expire_date) {
          return -1; // a has expire_date, b does not, so a should come first
        } else if (!a.expire_date && b.expire_date) {
          return 1; // b has expire_date, a does not, so b should come first
        } else if (a.expire_date && b.expire_date) {
          return new Date(a.expire_date) - new Date(b.expire_date); // sort by expire_date from earliest to latest
        } else {
          return a.plan_name.localeCompare(b.plan_name); // sort alphabetically by plan_name
        }
      });

      return data;
    },
    headAvaiMemberships() {
      return this.sortedOrgPlans;
    },
    allMemberShip() {
      const data = [];
      this.allPlans.forEach(p => {
        const plan_label = getPlanLabel(p.product_type, p.package);
        data.push({ ...p, plan_label });
      });
      return data;
    },
    buildingClass() {
      return this.class;
    },
    avaiMemberships() {
      const data = [];

      this.sortedOrgPlans.forEach(plan => {
        let newPlan = {
          label: plan.plan_name + plan.expire_date_label,
          value: plan.id,
        };

        if (plan.qty <= plan.qty_assigned) {
          newPlan["disabled"] = true;
        }

        data.push(newPlan);
      });

      data.push({
        label: this.$t("classes.classes_details.edit_class.table.invite_only"),
      });

      return data;
    },
    combineHeadAvailableMemberships() {
      return this.combineMemberships(this.headAvaiMemberships);
    },
    users() {
      const rootObj = (this && this.class && this.class.users) || [];
      return rootObj.map(el => ({ ...el, valueNewLicense: 0 }));
    },
  },
  watch: {
    class: {
      deep: true,
      handler(value) {
        const rootObj = (value && value.users) || [];
        this.dataUsers = rootObj.map(el => ({ ...el, valueNewLicense: "" }));
      },
    },
    dataUsers: {
      deep: true,
      handler(value) {
        this.selectedLicense = value.reduce((result, curr) => {
          if (curr.valueNewLicense) {
            if (result[curr.valueNewLicense]) {
              result[curr.valueNewLicense].push(curr);
            } else {
              result[curr.valueNewLicense] = [curr];
            }
          }
          return result;
        }, {});

        this.saveLicenseState(value);
      },
    },
    selectedLicense: {
      deep: true,
      handler(value) {
        const data = Object.entries(value);
        if (data.length > 0) {
          data.forEach(([paymentId, users]) => {
            users.forEach(user => {
              const options = this.filterOptions(user);
              const found = options.find(option => option.value.toString().includes(paymentId));
              if (found) this.userSelectedLicense[user.id] = found.value;
            });
          });
        }
      },
    },
  },
  props: {
    currentStep: {
      type: Number,
      default: 4,
    },
    componentStep: {
      type: Number,
      default: 4,
    },
  },
  methods: {
    removeUser(learner_id) {
      this.modals.showRemoveAccountModal = true;
      this.userIdRemoved = learner_id;
    },
    // assignLicense(learner_id, plan) {
    //   // TODO: check license available
    //   if (!plan) {
    //     return;
    //   }
    //   this.modals.showAssignLicenseModal = true;
    //   this.userIdAssignMembershipSelected = learner_id;
    //   this.planSelected = plan;
    //   this.membershipSelectedDisplayName = this.avaiMemberships.find(u => u.value == plan).label;
    //
    //   this.userAssignMembershipSelectedDisplayName = this.users.find(u => u.id == learner_id).text;
    // },
    cancelAssignLicense() {
      this.membershipSelectedDisplayName = "";
      this.userAssignMembershipSelectedDisplayName = "";
      this.resetMembership("", this.userIdAssignMembershipSelected);
      this.changeMembership();
      this.userIdAssignMembershipSelected = null;
      this.planSelected = null;
    },
    async handelRemoveFromClasses(isRemoveUserFromSystem = false) {
      try {
        // call api remove user
        await this.$store.dispatch("classes/removeUserFromClass", {
          groupId: this.class.id,
          studentId: this.userIdRemoved,
        });
        // show success message
        const message = this.$i18nLabelsHelper(
          this.$store.getters["organization/currentOrganizationType"],
          "remove_from_class_success"
        );
        successMessage(this.$t(message))(this);
        if (isRemoveUserFromSystem) {
          try {
            await this.removeUserFromSystem({ studentId: this.userIdRemoved });
            const message = this.$t("common.remove_user_from_system_success");
            successMessage(this.$t(message))(this);
          } catch (error) {
            const message = this.$t("common.remove_user_from_system_warning");
            warningMessage(this.$t(message))(this);
          }
        }
        // reload current page
        await this.fetchPage(this.currentPage);
      } catch (error) {
        const message = this.$i18nLabelsHelper(this.currentOrganizationType, "remove_from_class_warning");
        return warningMessage(this.$t(message))(this);
      }
    },
    async handleAssignLicense() {
      try {
        // call api assign license
        await this.$store.dispatch("classes/assignStudentLicense", {
          plan: this.planSelected,
          studentId: this.userIdAssignMembershipSelected,
        });
        // show success message
        const message = this.$i18nLabelsHelper(
          this.$store.getters["organization/currentOrganizationType"],
          "assign_license_to_user_success"
        );
        successMessage(this.$t(message))(this);

        // reset license state
        this.onAssignLicenseSuccess(this.planSelected, this.userIdAssignMembershipSelected);
        this.changeMembership();

        this.membershipSelectedDisplayName = "";
        this.userAssignMembershipSelectedDisplayName = "";
        this.userIdAssignMembershipSelected = null;
        this.planSelected = null;
      } catch (error) {
        const message = this.$i18nLabelsHelper(this.currentOrganizationType, "assign_license_to_user_warning");
        return warningMessage(this.$t(message))(this);
      }
    },
    onAssignLicenseSuccess(membershipId, studentId) {
      const newEmails = [];
      this.users.forEach(user => {
        if (user.id === studentId) {
          const newEmail = {
            ...user,
            package: membershipId,
            disabled: !!membershipId,
            new_license: true,
          };

          newEmails.push(newEmail);
        } else {
          const newEmail = { ...user };
          newEmails.push(newEmail);
        }
      });
      this.updateBuildingClass({
        users: newEmails,
      });
    },
    resetMembership(plan_id, studentId) {
      const newEmails = [];
      this.users.forEach(user => {
        if (user.id === studentId) {
          const newEmail = {
            ...user,
            plan_id: plan_id,
          };

          newEmails.push(newEmail);
        } else {
          const newEmail = { ...user };
          newEmails.push(newEmail);
        }
      });
      this.updateBuildingClass({
        users: newEmails,
      });
    },
    changeMembership() {
      this.orgPlanDetails.forEach(plan => {
        const qty_assigned_list = this.users.filter(u => {
          if (u.plan_id != plan.plan_id) {
            return false;
          }
          if (u.new_license) {
            return true;
          }
          if (u.disabled) {
            return false;
          }
          return true;
        });
        plan["qty_assigned"] = qty_assigned_list.length;
      });
    },
    getOrganizationContracts() {
      let url = `v1/checkouts/${this.currentOrganizationId}/payments`;

      return axios.get(url).then(response => {
        const payments = response.data;
        if (payments.length > 0) {
          payments.forEach(payment => {
            let plan_details = payment.plan_details;
            plan_details.forEach(plan => {
              const qty_assigned_list = this.users.filter(u => u.plan_id == plan.id);
              const nowTime = new Date().getTime();
              let validTime = null;
              if (plan.auto_active_license_date && plan.is_subscription) {
                validTime = this.expiredAtForAutoActive(plan.auto_active_license_date, plan.package);
              }
              // check remaining license and not expired yet, if payment offline validtime = null
              if (plan.number_of_learner > plan.number_of_license_used && (validTime >= nowTime || !validTime)) {
                const newPlan = {
                  id: plan.id,
                  package: plan.package,
                  qty: plan.number_of_learner - plan.number_of_license_used,
                  qty_assigned: qty_assigned_list.length,
                  product_types: plan.product_types,
                  expire_date: validTime
                    ? formatDate(validTime, this.currentOrganization.timezone, "MMM dd, yyyy")
                    : null,
                  product_type: plan.product_types[0],
                };
                this.orgPlanDetails.push(newPlan);
              }

              // save all plans
              this.allPlans = [
                ...this.allPlans,
                {
                  id: plan.id,
                  package: plan.package,
                  qty: plan.number_of_learner - plan.number_of_license_used,
                  qty_assigned: qty_assigned_list.length,
                  product_types: plan.product_types,
                  expire_date: validTime
                    ? formatDate(validTime, this.currentOrganization.timezone, "MMM dd, yyyy")
                    : null,
                  product_type: plan.product_types[0],
                },
              ];
            });
          });

          this.addAvailablePackagesToUser();
        }
      });
    },
    handleClickContinute() {
      this.$emit("next-step", this.currentStep);
    },
    ...mapActions({
      updateBuildingClass: "classes/updateBuildingClass",
      saveLicenseState: "classes/saveLicenseState",
    }),
    async fetchPage(page) {
      if (!this.class || !this.class.id) {
        return;
      }
      // fetch user from classes
      // var { status, data } = await this.$store.dispatch("classes/getCurrentClassUsers", {
      //   from: Date.now(),
      //   to: Date.now(),
      //   page: page,
      //   search: null,
      // });
      const { status, data } = await this.$store.dispatch("classes/getCurrentClassUsersEditPage");

      if (!status) {
        return;
      }

      // this.currentPage = page;
      // this.total = data.count;
      // const students = data.results;
      // const emails = [];
      this.currentPage = page;
      this.total = data.length;
      const students = data;
      const emails = [];

      // parse students
      if (students) {
        students.forEach(student => {
          emails.push({
            id: student.id,
            text: student.email,
            package: student.package,
            plan_id: student.plan_id,
            plan_ids: student.plan_ids,
            disabled: !!student.plan_id,
            new_license: false,
            first_name: student.first_name,
            last_name: student.last_name,
          });
        });
      }
      await this.updateBuildingClass({
        users: emails,
      });
    },
    addAvailablePackagesToUser() {
      this.dataUsers.forEach(user => {
        const availablePackages = [];
        if (user.plan_ids && user.plan_ids.length > 0) {
          user.plan_ids.forEach(plan_id => {
            const plan = this.orgPlanDetails.find(plan => plan.id == plan_id);
            if (plan !== undefined) {
              availablePackages.push(this.unique_package_str(plan));
            }
          });
        }

        user.available_packages = availablePackages;
      });
    },
    expiredAtForAutoActive(date_auto_active, membership) {
      return addMonths(new Date(date_auto_active), PLAN_MONTH_DURATION[membership]);
    },
    uniq(arr) {
      return [...new Set(arr)];
    },
    findExistLicense(user) {
      const plan_ids = this.uniq(user.plan_ids);
      return this.allMemberShip.filter(el => plan_ids.includes(el.id));
    },
    handleAssignAll(license) {
      let { id, qty } = license;
      this.handleClearAll();

      let items = [];
      if (id.toString().includes("_")) {
        // case multiple
        const itemStrings = id.split("_");

        items = itemStrings.map(itemString => {
          const [key, value] = itemString.split("|");

          return {
            id: parseInt(key),
            qty: parseInt(value),
            qty_assigned: 0,
          };
        });
      } else if (id.toString().includes("|")) {
        // case one
        const itemStrings = id.split("|");
        id = parseInt(itemStrings[0]);
        qty = parseInt(itemStrings[1]);
      }

      if (items.length > 0) {
        for (let i = 0; i < this.dataUsers.length; i++) {
          const currentUser = this.dataUsers[i];

          for (let j = 0; j < items.length; j++) {
            const currentItem = items[j];
            const plan = this.orgPlanDetails.find(plan => plan.id == currentItem.id);

            if (currentItem.qty_assigned < currentItem.qty) {
              const planIds = currentUser.plan_ids || [];
              const availablePackages = currentUser.available_packages || [];

              if (!planIds.includes(currentItem.id) && !availablePackages.includes(this.unique_package_str(plan))) {
                currentUser.valueNewLicense = currentItem.id;
                currentItem.qty_assigned++;
              }
              // Move to the next user
              break;
            }
          }
        }
      } else {
        let numberLicenseRemain = qty;
        const plan = this.orgPlanDetails.find(plan => plan.id == id);

        this.dataUsers = this.dataUsers.map(el => {
          if (numberLicenseRemain <= 0) {
            return el;
          }

          const planIds = el.plan_ids || [];
          const availablePackages = el.available_packages || [];

          if (!planIds.includes(id) && !availablePackages.includes(this.unique_package_str(plan))) {
            numberLicenseRemain = numberLicenseRemain - 1;
            return { ...el, valueNewLicense: id };
          }

          return el;
        });
      }
    },
    handleClearAll() {
      this.dataUsers = this.dataUsers.map(el => ({ ...el, valueNewLicense: "" }));
      this.userSelectedLicense = {};
    },
    filterOptions(user) {
      const plan_ids = this.uniq(user.plan_ids);
      const result = this.avaiMemberships
        .filter(el => !plan_ids.includes(el.value))
        .filter(el => {
          if (!el.value) return true;
          const item = this.headAvaiMemberships.find(plan => plan.id === el.value);
          if (!item || !this.selectedLicense[item.id] || user.valueNewLicense) return true;
          const remaining = item.qty - this.selectedLicense[item.id].length;
          return remaining > 0;
        });
      return this.combineOptions(result);
    },
    separateAvailableMemberships(data) {
      const oldData = [];
      const summedData = {};

      data.forEach(item => {
        if (item.expire_date !== null) {
          oldData.push(item);
        } else {
          const key = this.unique_package_str(item);
          summedData[key] = (summedData[key] || 0) + (item.qty - item.qty_assigned);
        }
      });

      return { oldData, summedData };
    },
    createSummedAvailableMemberships(summedData, data) {
      return Object.keys(summedData).map(key => {
        const [packageVal, productType] = key.split("+");
        const idQtyPairs = data
          .filter(item => item.expire_date === null && item.package === packageVal && item.product_type === productType)
          .map(item => `${item.id}|${item.qty - item.qty_assigned}`)
          .join("_");
        const output = {
          id: idQtyPairs,
          package: packageVal,
          qty: summedData[key],
          product_type: productType,
        };

        output["plan_label"] = summedData[key] + " " + getPlanLabel(productType, packageVal);

        return output;
      });
    },
    unique_package_str(obj) {
      if (obj === undefined) return;
      return `${obj.package}+${obj.product_type}`;
    },
    getIdArr(id) {
      const idStr = id.toString();
      if (idStr.includes("_")) {
        return idStr.split("_").map(pair => {
          const [id] = pair.split("|");
          return parseInt(id);
        });
      } else if (idStr.includes("|")) {
        const [id] = idStr.split("|");
        return [parseInt(id)];
      }
      return [parseInt(id)];
    },
    combineMemberships(data) {
      const { oldData, summedData } = this.separateAvailableMemberships(data);
      const summedDataArray = this.createSummedAvailableMemberships(summedData, data);

      return [...oldData, ...summedDataArray];
    },
    combineOptions(data) {
      const combinedData = {};

      data.forEach(item => {
        const label = item.label;

        if (label in combinedData) {
          combinedData[label].value += `_${item.value}`;
        } else {
          combinedData[label] = { label: label, value: item.value || "" };
        }
      });

      return Object.values(combinedData);
    },
    handleChangeUserSelectedLicense(value, user) {
      if (value) {
        let paymentId;
        if (value.toString().includes("_")) {
          paymentId = parseInt(value.toString().split("_")[0]);
        } else {
          paymentId = value;
        }
        this.userSelectedLicense[user.id] = value;
        user.valueNewLicense = paymentId;
      } else {
        this.userSelectedLicense[user.id] = "";
        user.valueNewLicense = "";
      }
    },
  },
  mounted() {
    try {
      this.getOrganizationContracts();
    } catch {
      return warningMessage(this.$t("common.generic_error_message"))(this);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";

p {
  font-weight: 300;
  font-size: 18px;
  color: $dark-blue-2;
  margin-bottom: 32px;
}

.remove-user {
  cursor: pointer;

  &:hover i {
    transform: scale(1.3);
  }

  i {
    transition: all 0.2s ease-in-out;
  }
}

.el-row {
  flex-wrap: wrap;
}

.form-row {
  display: flex;
  margin-bottom: 32px;

  .select-license {
    padding-top: 16px;
    margin-right: 32px;
  }

  .elsa-primary-button {
    margin-right: 24px;
  }
}

.select-membership-single {
  margin-bottom: 0px !important;
}

.el-form {
  padding-bottom: 0;
}

.elsa-table-layout-footer {
  padding-top: 48px;
}

.elsa-table-layout-header,
.elsa-table-layout-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div {
    align-self: center;
  }
}

.el-table__row .el-tag.exist_license {
  color: $success;
  font-size: 0.8rem;
  max-width: 160px;
}

.wrap-tags {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.wrap-tags .el-tag {
  padding: 0 5px;
}
</style>
